import { useMemo, useRef } from 'react'
import { AlignmentResultsChart } from '../classes/AnnotationResultsChart'


/* Hook returns:
    - Reference for the rendered plot
    - Object of type AlignmentResultsChart
*/
export const AlignmentResultsChartHook = ({ parameters }) => {

    const objectReference = useRef()
    const initialParameters = useRef(parameters)
    const chart = useMemo(() => new AlignmentResultsChart(initialParameters.current, objectReference), [])

    return ([objectReference, chart])

}
